module.exports = __webpack_public_path__ + "img/1207687960.7f42e75a.jpg";